<template>
  <i18n-t
    :keypath="keypath"
    :plural="count"
    :count="count"
    :tag="tag"
  >
    <template
      v-for="{ name, camelCaseName } in slotNames"
      v-slot:[camelCaseName]
    >
      <slot :name="name" />
    </template>
  </i18n-t>
</template>

<script lang="ts" setup>
import { camelCase } from 'lodash-es'
import type { TranslationKey } from '@widgets/shared/services/translate/types'
import { computed, useSlots } from '@/composition/vue/compositionApi'

defineProps<{
  keypath: TranslationKey
  count?: number
  tag?: string
}>()

const slots = useSlots()
const slotNames = computed(() => {
  const names = Object.keys(slots)
  return names.map((name) => ({
    name,
    camelCaseName: camelCase(name),
  }))
})
</script>
